import React from "react";

const CreateSection = () => {
  const sectionContent = [
    {
      icon: "fa-solid fa-wallet",
      bgColor : '#beaaf7',
        iconColor : '#8358ff',
      title: "1. Setupyourwallet",
      content:
        "Once You have Set Up Your Wallet Of Choice, Connect It To OpenSeaby Clicking The NFT Marketplacein The Topright Corner.",
    },
    {
      icon: "fa-solid fa-images",
      bgColor : '#c4f2e3',
        iconColor : '#10b981',
      title: "2. CreateYourCollection",
      content:
        "Click Create And Set Up Your Collection. Add Social Links, A Description, Profile & Banner Images, Andset A Secondary Sales Fee.",
    },
    {
      icon: "fa-brands fa-hornbill",
      title: "3. AddYourNFTs",
      bgColor : '#cddffb',
        iconColor : '#428af8',
      content:
        "Upload Your Work (Image, Video, Audio, Or 3D Art), Add A Title And Description, And Customize Your NFTswith Properties, Stats.",
    },
    {
      icon: "fa-solid fa-wallet",
      bgColor : '#ffd0d0',
        iconColor : '#ef4444',
      title: "4. ListThemForSale",
      content:
        "Choose Between Auctions, Fixed-Price Listings, And Declining-Price Listings. You Choose How You Want Tosell Your NFTs!",
    },
  ];

  return (
    <div className="create-section section-padding">
      <div className="container ">
        <h2 className="text-center mb-5 text-white " data-aos='zoom-in' >Create And Sell Your NFTs</h2>
        <div className="row g-lg-5 g-4 mt-5">
          {sectionContent.map((element, index) => {
            return (
              <div className="col-lg-3 col-sm-6 mt-5" key={index} data-aos='zoom-in' >
                <div className="create-card text-center">
                  <div className="icon mb-md-5 mb-4" style={{backgroundColor : element.bgColor}} >
                    <i className={element.icon} style={{backgroundColor : element.iconColor}} ></i>
                  </div>
                  <h4 className="text-white  mb-4">{element.title}</h4>
                  <p style={{ textAlign: "justify", textAlignLast: "center" }}>
                    {element.content}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CreateSection;
